import { RadioGroupField, RadioGroupFieldProps } from 'components/form'
import { RastreioCancerPerguntaOpcaoEnum } from 'graphql/types.generated'

const baseOptions = [
  { value: RastreioCancerPerguntaOpcaoEnum.PESSOA_VIVENDO_COM_HIV, label: 'Pessoa vivendo com HIV' },
  {
    value: RastreioCancerPerguntaOpcaoEnum.OUTRAS_SITUACOES_IMUNOSSUPRESSAO,
    label: 'Outras situações de imunossupressão',
  },
]

const nuncaFezPreventivoOption = {
  value: RastreioCancerPerguntaOpcaoEnum.NUNCA_FEZ_PREVENTIVO_ANTERIORMENTE,
  label: 'Nunca fez preventivo anteriormente',
}

interface SituacaoEspecialRadioFieldProps
  extends Omit<RadioGroupFieldProps<RastreioCancerPerguntaOpcaoEnum>, 'options'> {
  showNuncaFezPreventivo?: boolean
}

export function SituacaoEspecialRadioField(props: Readonly<SituacaoEspecialRadioFieldProps>) {
  const { showNuncaFezPreventivo, ...rest } = props
  const options = showNuncaFezPreventivo ? [...baseOptions, nuncaFezPreventivoOption] : baseOptions
  return (
    <RadioGroupField label='Situação especial' {...rest} lines={showNuncaFezPreventivo ? 2 : 1} options={options} />
  )
}
